var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5L10.3536 12.8536L10 13.2071L9.64645 12.8536L10 12.5ZM15.3536 7.85355L10.3536 12.8536L9.64645 12.1464L14.6464 7.14645L15.3536 7.85355ZM9.64645 12.8536L4.64645 7.85355L5.35355 7.14645L10.3536 12.1464L9.64645 12.8536Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThin);
export default __webpack_public_path__ + "static/media/arrow-thin.5dcdd39d3459a7af2b945afb5a297e78.svg";
export { ForwardRef as ReactComponent };